module.exports = __webpack_public_path__ + "fonts/oktaVerify_70x70.00aa672ea67517ca19e2b110d650e03f.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/oktaVerify_70x70.png
// module id = 766
// module chunks = 9